import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {


  constructor(private http: HttpClient) { }

  api_root: string = environment.REST_API_SERVER;

  upload(file: File, imgName: string, title: string, boardId: any, workspaceId: any): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  profileProjectsupload(file: File, imgName: string): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);

    const req = new HttpRequest('POST', `${api_root}workspaces/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  uploadImageVersion(file: File, imgName: string, title: string, boardId: any, workspaceId: any, imageId: any): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/` + imageId + `/add_version/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  uploadWithResolution(file: File, imgName: string, title: string, boardId: any, workspaceId: any, height: any, width: any): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);
    formData.append('width', width);
    formData.append('height', height);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  uploadWithResolutionReplace(file: File, imgName: string, title: string,
    boardId: any, workspaceId: any, isReplace: string): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);
    formData.append('width', "");
    formData.append('height', "");
    formData.append('replace', isReplace);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  uploadWithResolutionKeepBoth(file: File, imgName: string, title: string,
    boardId: any, workspaceId: any, height: any, width: any, isKeepBoth: string): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);
    formData.append('width', width);
    formData.append('height', height);
    formData.append('keep', isKeepBoth);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  uploadWithResolutionKeepBothNew(file: File, imgName: string, title: string,
    boardId: any, workspaceId: any, isKeepBoth: string): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);
    formData.append('width', "");
    formData.append('height', "");
    formData.append('keep', isKeepBoth);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  getFiles(workspaceId: any, boardId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/';
    return this.http.get(url);
  }

  getProfileFiles(){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/' + '/images/';
    return this.http.get(url);
  }

  uploadFigmaFile(fileLink: string, boardId: any, workspaceId: any): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('figma_link', fileLink);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/figma/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  uploadDocFile(fileLink: string, boardId: any, workspaceId: any): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', fileLink);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  getArchiveAssets(workspaceId: any, boardId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/1/get_archieved_assets/';
    return this.http.get(url);
  }

  getArchiveBoards(workspaceId: any, boardId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/get_archieved_boards/';
    return this.http.get(url);
  }

  getArchiveFigmaLinks(workspaceId: any, boardId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/figma/1/get_archieved_figma/';
    return this.http.get(url);
  }

  getSharedAssetsFiles(token: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'shared/' + token + '/get_assets/';
    return this.http.get(url);
  }

  getSharedBoardFiles(token: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'shared/' + token + '/get_boards/';
    return this.http.get(url);
  }

  uploadUserProjectImages(file: File, imgName: string): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);

    const req = new HttpRequest('POST', `${api_root}users/upload_share_asset/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }
}
